import { Grid, Modal } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import {
  WorkPlanListProps,
  WorkPlanContainer,
  KalenderIcon,
  Info,
  AbfahrtIcon,
} from "../../utils/types";
import { ArbeitsplanDetailsModal } from "./ArbeitsplanDetailsModal";
import { Monteur } from "./Monteur";
import _ from "lodash";
import {
  getArbeitsplanTitle,
  getDateInfosList,
  getEarliestTime,
} from "../../utils/helperFunctions";
import { ArbeitsplanTitleWithUnderline } from "../../components/common/ArbeitsplanTitleWithUnderline";

export const GeneralArbeitsplanListItem: React.FC<WorkPlanListProps> = ({
  workPlanList,
  userList,
}) => {
  const mitarbeiter = [
    ...new Set(
      workPlanList.flatMap((plan) =>
        plan.mitarbeiter?.split(",").map((x) => x?.trim())
      )
    ),
  ];
  const mitarbeiterUserList = userList.filter((user) =>
    mitarbeiter.includes(String(user.mitarbeiternummer))
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { earliestDateMoment, latestDateMoment, isCurrentDateInRange } =
    getDateInfosList(workPlanList);
  const earliestDate = getEarliestTime(workPlanList).replace(
    new RegExp(":[0-9]*.0000000"),
    ""
  );
  const workPlanTitle = getArbeitsplanTitle(workPlanList[0]);

  return (
    <>
      <Grid item xs={12} md={6}>
        <WorkPlanContainer
          style={{
            outline: isCurrentDateInRange ? "3px solid #1d9538" : "none",
          }}
        >
          <div onClick={() => setIsModalOpen(true)}>
            <ArbeitsplanTitleWithUnderline title={workPlanTitle} />
            <Info>
              <div>
                <KalenderIcon />
                {earliestDateMoment.format("DD.MM.YYYY")}{" "}
                {latestDateMoment &&
                  ` - ${latestDateMoment.format("DD.MM.YYYY")}`}
              </div>
              <div>
                <AbfahrtIcon />
                Abfahrt {earliestDate}
              </div>
              <Monteur
                userList={mitarbeiterUserList}
                bauleiter={workPlanList[0].bauleiter}
              />
            </Info>
          </div>
        </WorkPlanContainer>
      </Grid>
      <ArbeitsplanDetailsModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        workPlanList={workPlanList}
        userList={userList}
      />
    </>
  );
};
